import ConfirmSignIn from '../components/ConfirmSignIn';
import React from 'react';
import action from '../actions/confirmSignIn';
import routing from '../services/routing';
import queryString from '../services/queryString';

export const getContext = (challengeName?: string) => {
    return challengeName === 'EMAIL_OTP' ? 'confirmEmailOtp' : 'confirmSignIn';
};

export class ConfirmSignInRoute extends React.PureComponent {
    render() {
        const params = queryString.parse(routing.location.search);
        const challengeName = params.challengeName as string | undefined;
        const context = getContext(challengeName);
        return <ConfirmSignIn context={context} action={action} challengeName={challengeName} />;
    }
}

export default ConfirmSignInRoute;
